import {Injectable} from '@angular/core';
import {firstValueFrom, Observable, of, Subject} from 'rxjs';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment.dev';
import {map} from 'rxjs/operators';
import {DepartmentCodebookModel} from '../models/codebook/department-codebook.model';
import {FacultyCodebookModel} from '../models/codebook/faculty-codebook.model';
import {BaseResultModel} from '../models/base-result.model';

export enum CODEBOOK_ITEMS {
    faculties = "faculties",
    departments = "departments",
}

@Injectable({
    providedIn: 'root',
})
export class CodebooksService {

    private apiUrl = `${environment.API_URL}`;

    protected storageKey = 'codebookItems';

    preferencesChanged: Subject<any> = new Subject<any>();

    protected values: { [key: string]: any } = {};

    private isLoading: { [key: string]: boolean } = {};

    constructor(
        private http: HttpClient
    ) {
    }

    /**
     * Fetch department by ID.
     */
    getDepartmentById(id: number): Observable<DepartmentCodebookModel> {
        const params = new HttpParams().set('keys', id.toString());
        return this.http.get<DepartmentCodebookModel>(`${this.apiUrl}/department`, { params });
    }

    /**
     * Fetch all departments by faculty ID.
     */
    getDepartmentsByFacultyId(facultyId: number): Observable<DepartmentCodebookModel[]> {
        const params = new HttpParams().set('keys', facultyId.toString());
        return this.http.get<DepartmentCodebookModel[]>(`${this.apiUrl}/department/getAllByFacultyId`, { params }).pipe(
            map((response: any) => response.results as DepartmentCodebookModel[])
        )
    }

    getFacultyById(id: number): Observable<FacultyCodebookModel> {
        const params = new HttpParams().set('keys', id.toString());
        return this.http.get<FacultyCodebookModel>(`${this.apiUrl}/faculty`, { params });
    }

    getAllFaculties(): Observable<FacultyCodebookModel[]> {
        return this.http.get<FacultyCodebookModel[]>(`${this.apiUrl}/faculty/all`)
            .pipe(
                map((response: any) => response.results as FacultyCodebookModel[])
            )
    }

    async get(key: string, defaultValue = undefined) {
        if (typeof this.values[key] !== "undefined") {
            return this.values[key];
        }

        if (this.values[key]) {
            return of(this.values[key]);
        }

        if (this.isLoading[key]) {
            return new Observable((observer) => {
                this.preferencesChanged.subscribe((data) => {
                    if (data.key === key) {
                        observer.next(data.value);
                        observer.complete();
                    }
                });
            });
        }

        let items = [];

        items = this.checkDataFromLocalStorage(key);

        if (!items) {
            this.isLoading[key] = true;

            switch (key) {

            }
        }

        if (items) {
            this.isLoading[key] = false;

            this.values[key] = items;

            this.set(key, items, true);
        }

        return items;
    }

    checkDataFromLocalStorage(key: string) {
        const localData = window.localStorage.getItem(this.storageKey);
        if (localData) {
            const data = JSON.parse(localData);
            if (data[key]) {
                return data[key];
            }
        }
        return null;
    }

    set(key: string, value: any, save = true) {
        this.values[key] = value;
        if (save) {
            this.saveToLocalStorage();
        }
        this.preferencesChanged.next({ key, value });
    }

    saveToLocalStorage() {
        window.localStorage.setItem(this.storageKey, JSON.stringify(this.values));
    }

    async preloadCodebooks() {
        // await this.get(CODEBOOK_ITEMS.faculties);
        // await this.get(CODEBOOK_ITEMS.departments);
    }
}
